import DemandePiecesSheet from "./DemandePiecesSheet";
import DemandePiecesValidationDialog from "./DemandePiecesValidationDialog";

export default {
    install(Vue) {
        Vue.component("a-demande-pieces-sheet", DemandePiecesSheet);
        Vue.component("a-demande-pieces-validation-dialog", DemandePiecesValidationDialog);
    }
}
